import axios from './axios'
import { v4 as uuidv4 } from 'uuid'

const createChat = (id, accessKey, massege, storyUuid) => axios.post('/chat', {
  requestUuid: uuidv4()?.toString(),
  accessKey: accessKey,
  userToUuid: id,
  text: massege,
  storyUuid: storyUuid,
})

const addedStoryChat = (accessKey, storyUuid, userUuid) => axios.post(`/chat/private/${userUuid}/story/${storyUuid}/add`, {
  accessKey: accessKey,
})

const getChats = (accessKey, category) => axios.get(`/chat?status=${category}&accessKey=${accessKey}`)
const acceptChatUser = (accessKey, chatUuid, type) => axios.post(`/chat/${chatUuid}/${type}`, {
  accessKey: accessKey,
})
const createMeeting = (accessKey, chatUuid, dateCreate) => axios.post(`/chat/${chatUuid}/meeting`, {
  accessKey: accessKey,
  start: dateCreate,
})

const edditMeetingTime = (accessKey, meetingUuid, start) => axios.put(`meeting/${meetingUuid}/time`, { start, accessKey })

const acceptMeeting = (accessKey, meetingUuid, type) => axios.post(`/meeting/${meetingUuid}/${type}`, {
  accessKey: accessKey,
})

const getMessages = (accessKey, chatUuid) => axios.get(`/message?accessKey=${accessKey}&thread=${chatUuid}&limit=10000`)

const getNotifications = (accessKey, type, category, read) => axios.get(`/notifications?accessKey=${accessKey}&group=${type}&type=${category}&read=${read}`)

const getNotificationsRead = (accessKey, type, read) => axios.get(`/notifications?accessKey=${accessKey}&group=${type}&read=${read}`)

const seenMeetings = (accessKey, id) => axios.post(`/message/${id}/seen`, {
  read: true,
  accessKey,
})

const getMeeting = (accessKey, id) => axios.get(`/meeting/${id}?accessKey=${accessKey}`)

const sendNewMessage = (accessKey, data) => axios.post('/message', {
  accessKey: accessKey,
  message: { ...data },
})

const deleteMessage = (accessKey, id) => axios.delete(`message?accessKey=${accessKey}&messageUuid=${id}`)

const editMessage = (id, data) => axios.put(`/message/${id}`, {
  ...data,
})

const seenNotifications = (accessKey, id) => axios.post(`/notifications/${id}/seen`, {
  accessKey,
})

const seenMessage = (accessKey, id) => axios.post(`/message/${id}/seen`, {
  accessKey,
})

const deleteChat = (accessKey, id) => axios.delete(`/chat/${id}?accessKey=${accessKey}`)

const getChatById = (id, accessKey) => axios.get(`/chat/${id}?accessKey=${accessKey}`)

const sendReviewSuccess = (accessKey, meetingUuid, number, text) => axios.post(`/meeting/${meetingUuid}/review/success`, {
  accessKey,
  rating: number,
  feedback: text,
})

const sendReviewFailure = (accessKey, meetingUuid, number) => axios.post(`/meeting/${meetingUuid}/review/failure`, {
  accessKey,
  reason: number,
})

const keepChat = (accessKey, chatId) => axios.post(`/chat/${chatId}/keep`, {
  accessKey,
})
const keepChatDelete = (accessKey, chatId) => axios.delete(`/chat/${chatId}?deletedReason=3&accessKey=${accessKey}`)

const obj = {
  createChat,
  getChats,
  acceptChatUser,
  createMeeting,
  acceptMeeting,
  getMessages,
  getNotifications,
  seenMeetings,
  getMeeting,
  sendNewMessage,
  deleteMessage,
  seenNotifications,
  seenMessage,
  edditMeetingTime,
  deleteChat,
  getNotificationsRead,
  addedStoryChat,
  editMessage,
  getChatById,
  sendReviewSuccess,
  sendReviewFailure,
  keepChat,
  keepChatDelete,
}

export default obj
